<div class="app__loading animated fast fadeIn" *ngIf="Loading">
  <div class="ui-loader">
    <div class="ui-loader__base"></div>
  </div>
</div>
<div class="app__wrapper" [ngClass]="{'loading': Loading}">
  <router-outlet></router-outlet>
</div>
